enum QueueStatusEnum {
    NOT_STARTED = 1,
    PROCESSING = 2,
    COMPLETED = 3,
    ERRORED = 4,
    EMAILED = 5,
    CANCELLED = 6,
}

export default QueueStatusEnum;
